// ============================================================================
// AppEmbedHost.tsx — ГРАНИЦА ИЗОЛЯЦИИ встроенного embed (AppEmbed).
// AppEmbed — лёгкий контекст (НЕ полный AppHost): ErrorBoundary + размеры +
// «Перезагрузить» (embed упал → плашка, хост/чат живы). Внешние iframe —
// sandbox + lazy; same-origin компоненты — обычный React через AppEmbedHost.
// ============================================================================

import { Component, type ErrorInfo, type ReactNode } from 'react';
import { createLogger } from '@/lib/logger';

const log = createLogger('AppEmbed');

export class AppEmbedHost extends Component<{ children: ReactNode }, { error: Error | null }> {
  state: { error: Error | null } = { error: null };

  static getDerivedStateFromError(error: Error) {
    return { error };
  }
  componentDidCatch(error: Error, _info: ErrorInfo) {
    // Встраиваемый модуль упал — логируем; хост (чат/страница) жив.
    log.warn('embed crashed: ' + error.message, error);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="flex flex-col items-center justify-center gap-2 rounded-md border border-destructive/20 bg-destructive/5 px-3 py-4 text-center">
          <div className="text-xs text-destructive">Встраиваемый модуль недоступен</div>
          <button
            type="button"
            className="text-[11px] border rounded px-2 py-0.5 hover:bg-accent"
            onClick={() => this.setState({ error: null })}
          >
            Перезагрузить
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
